// extracted by mini-css-extract-plugin
export default {"Container":"end-slide_Container__DySxV"};